import { ReactiveController, ReactiveControllerHost } from "lit";
import { Toast } from "../models";

/**
 * Controller for managing toast notifications.
 */
export class ToastController implements ReactiveController {
  private _toasts: Toast[] = [];
  private _nextId = 0;
  private _timers: ReturnType<typeof setTimeout>[] = [];

  constructor(private host: ReactiveControllerHost) {
    host.addController(this);
  }

  hostConnected() {}

  hostDisconnected() {
    this._timers.forEach(clearTimeout);
    this._timers = [];
  }

  get toasts() {
    return this._toasts;
  }

  show(message: string, type: Toast["type"] = "success") {
    const id = this._nextId++;
    const toast: Toast = { id, message, type };
    this._toasts = [...this._toasts, toast];
    this.host.requestUpdate();

    const timer = setTimeout(() => {
      this._timers = this._timers.filter((t) => t !== timer);
      this._toasts = this._toasts.filter((t) => t.id !== id);
      this.host.requestUpdate();
    }, 3000);
    this._timers.push(timer);
  }
}
